import { cn } from '@/lib/utils';

import type { PolymorphicComponentProps } from './types';

type BoxProps<E extends React.ElementType = 'div'> =
    PolymorphicComponentProps<E>;

/**
 * Box - Simple container
 * Maps to Figma frame without auto layout
 *
 * @example
 * <Box className="p-4 rounded-lg">
 *   {children}
 * </Box>
 */
export const Box = <E extends React.ElementType = 'div'>({
    as,
    className,
    children,
    ...props
}: BoxProps<E>) => {
    const Component = as || 'div';
    return (
        <Component className={cn(className)} {...props}>
            {children}
        </Component>
    );
};
